import { apiService } from "api/apiService";
import type { AISuggestionReport } from "shared/types/aiSuggestionReport.types";

export const postAISuggestionReport = async (
  report: AISuggestionReport,
): Promise<void> => {
  await apiService.post<void>("api/catwise-ai/report", report);
};
